// extracted by mini-css-extract-plugin
module.exports = {"data-tree-card":"data-tree-card--1O4tGCoV","disable":"disable--2PmiuaEV","data-tree-box":"data-tree-box--JcOSZpFi"};